import { CHAT_MEDIA_DELETION_FAILED_REASONS } from 'cpool-constants';
import { z } from 'zod';

// Manta _publish when Meta delete fails.
export const schemaChatMediaDeletionFailedPayload = z.object({
    mediaKey: z.string().min(1),
    reason: z.nativeEnum(CHAT_MEDIA_DELETION_FAILED_REASONS),
    reasonDetail: z.string().min(1),
});

export type Schema_ChatMediaDeletionFailedPayload = z.infer<typeof schemaChatMediaDeletionFailedPayload>;
